import React from "react"
import PropTypes from "prop-types"

const RankFirst = props => {
  const { color, width, height, ...other } = props

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 512 409.5"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <g id="circle" fill={color}>
        <path
          d="M139.75,425.91c-17.29-5.51-34.57-3.84-45.38,3.18,4.1,11.73,16.79,22.9,34.09,28.38s34.57,3.84,45.37-3.19C169.74,442.56,157,431.37,139.75,425.91Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M126.6,407.32c8.48-8.77,12.66-24,9.84-40.12s-11.88-28.89-22.8-34.05c-8.47,8.76-12.67,24-9.84,40.12S115.69,402.17,126.6,407.32Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M68.4,359.4c-14.93-9.42-31.86-11.92-44.15-7.71.58,12.32,9.52,26.12,24.44,35.54s31.86,11.92,44.15,7.71C92.25,382.61,83.32,368.83,68.4,359.4Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M79.27,273.78C70,280.63,63.7,294.19,63.78,309.67s6.52,28.78,15.86,35.25c9.28-6.86,15.57-20.41,15.49-35.9S88.61,280.26,79.27,273.78Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M55.14,248.65c11.41-2.32,23.18-11.94,30.1-26s7.15-28.74,1.7-38.49c-11.42,2.33-23.2,11.94-30.11,26S49.67,238.9,55.14,248.65Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M38.43,213.19c8.6-6.89,14.09-20.07,13.39-34.87s-7.37-27.27-16.58-33.13c-8.61,6.88-14.1,20.05-13.4,34.86S29.22,207.33,38.43,213.19Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M124.64,116.91c-10.52-1-23.64,4.15-34,14.49s-15.16,23.06-13.54,33c10.53,1.05,23.64-4.14,34-14.48S126.26,126.86,124.64,116.91Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M93.32,106.47C97.8,94,96.59,81.54,91.07,73.87,81.68,77,72.7,86.27,68.21,98.81s-3.27,24.93,2.26,32.59C79.85,128.27,88.83,119,93.32,106.47Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M144.13,82.05c9.68-9.58,14.23-21.39,12.76-30.67-9.79-1-22,3.78-31.69,13.37S111,86.15,112.45,95.4C122.24,96.42,134.46,91.64,144.13,82.05Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M34.93,262.48c-8.46-13-21.18-20.93-32.74-21.64-4.27,10.48-2.34,25.09,6.11,38.09S29.49,299.86,41,300.56C45.3,290.07,43.38,275.47,34.93,262.48Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M372.25,425.91c-17.28,5.46-30,16.65-34.08,28.37,10.8,7,28.08,8.68,45.38,3.19s30-16.65,34.08-28.38C406.82,422.07,389.54,420.4,372.25,425.91Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M375.56,367.2c-2.82,16.14,1.36,31.35,9.84,40.12,10.91-5.15,20-17.93,22.81-34.05s-1.37-31.36-9.85-40.12C387.44,338.31,378.38,351.07,375.56,367.2Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M443.6,359.4c-14.92,9.43-23.85,23.21-24.44,35.54,12.29,4.21,29.23,1.71,44.15-7.71s23.87-23.22,24.45-35.54C475.47,347.48,458.53,350,443.6,359.4Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M432.73,273.78c-9.34,6.48-15.78,19.77-15.85,35.24s6.21,29,15.47,35.9c9.35-6.47,15.78-19.77,15.86-35.25S442,280.63,432.73,273.78Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M425.08,184.19c-5.47,9.75-5.25,24.45,1.68,38.49s18.69,23.65,30.11,26c5.47-9.75,5.23-24.45-1.69-38.47S436.49,186.52,425.08,184.19Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M473.58,213.19c9.21-5.86,15.9-18.34,16.59-33.14s-4.8-28-13.4-34.86c-9.21,5.86-15.9,18.32-16.59,33.13S465,206.3,473.58,213.19Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M434.89,164.39c1.62-9.93-3.21-22.65-13.54-33s-23.46-15.54-34-14.49c-1.61,10,3.2,22.66,13.55,33S424.36,165.44,434.89,164.39Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M441.53,131.4c5.52-7.66,6.74-20.08,2.26-32.59S430.33,77,420.93,73.87c-5.52,7.66-6.73,20.07-2.25,32.6S432.14,128.27,441.53,131.4Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M399.55,95.4c1.46-9.25-3.07-21.08-12.75-30.65s-21.9-14.37-31.68-13.37c-1.48,9.28,3.08,21.09,12.75,30.67S389.76,96.42,399.55,95.4Z"
          transform="translate(0 -51.25)"
        />
        <path
          d="M509.81,240.84c-11.55.71-24.28,8.62-32.74,21.64S466.7,290.07,471,300.56c11.55-.7,24.3-8.62,32.74-21.63S514.08,251.32,509.81,240.84Z"
          transform="translate(0 -51.25)"
        />
      </g>
      <path
        fill={color}
        id="_1"
        data-name="1"
        d="M296.87,348.25h-47.8a19.9,19.9,0,0,1,0-2.32,223.84,223.84,0,0,0,1.46-27.75q0-56,0-112.06V203a265.45,265.45,0,0,0-35.44,1.44V163.75c2.68.29,5.27.66,7.88.83,4,.25,8,.5,12,.51q23.39.09,46.79,0c3.83,0,7.66-.31,11.49-.48l3.46-.17c-.28,4.27-.58,8.31-.82,12.36q-.27,4.66-.4,9.33c-.13,4.48-.28,9-.28,13.42q0,59.38,0,118.77a215,215,0,0,0,1.64,28.46A11.38,11.38,0,0,1,296.87,348.25Z"
        transform="translate(0 -51.25)"
      />
    </svg>
  )
}

RankFirst.propTypes = {
  color: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

RankFirst.defaultProps = {
  color: "#FFFFFF",
  width: 20,
  height: 20,
}

export default RankFirst
